import { render, staticRenderFns } from "./DeliveryDownload.vue?vue&type=template&id=4b598552&scoped=true"
import script from "./DeliveryDownload.vue?vue&type=script&lang=js"
export * from "./DeliveryDownload.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDownload.vue?vue&type=style&index=0&id=4b598552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b598552",
  null
  
)

export default component.exports